import { createBrowserHistory } from 'history';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

import { INSIGHTS_INSTRUMENTATION_KEY } from './constants/env';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: INSIGHTS_INSTRUMENTATION_KEY,
    enableAutoRouteTracking: false,
    disableTelemetry: INSIGHTS_INSTRUMENTATION_KEY === '',
    disableInstrumentationKeyValidation: true,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

if (INSIGHTS_INSTRUMENTATION_KEY != '') {
  appInsights.loadAppInsights();
}

const TRACK_INSIGHTS = true;

const trackEvent = (eventName: string, data: any) => {
  if (TRACK_INSIGHTS) {
    appInsights.trackEvent({ name: eventName }, data);
  }
};

const trackError = (error: any, data: any) => {
  if (TRACK_INSIGHTS) {
    appInsights.trackException({ error: error as Error, severityLevel: SeverityLevel.Error }, data);
  }
};

export { reactPlugin, appInsights, trackEvent, trackError };
